// extracted by mini-css-extract-plugin
module.exports = {"root":"AgreementModal_root__1sQY5","additionalInfo":"AgreementModal_additionalInfo__ibmbN"};